// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"e37d15ef","651":"8a4bd333","787":"3937fb76"}[chunkId] + ".chunk.js";
};